"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

exports.__esModule = true;
exports.default = void 0;

var _setYogaValue = _interopRequireDefault(require("./setYogaValue"));

/**
 * Set flex shrink attribute to node's Yoga instance
 *
 * @param {Number} flex shrink value
 * @param {Object} node instance
 * @return {Object} node instance
 */
var setFlexShrink = function setFlexShrink(value) {
  return function (node) {
    return (0, _setYogaValue.default)('flexShrink')(value || 1)(node);
  };
};

var _default = setFlexShrink;
exports.default = _default;